module.exports = __webpack_public_path__ + "img/p1.420c44e.jpg";